import { Icon, IconButton, Typography } from '@ace-clublabs/shared-component-library';
import { numberHelper } from '../utils/numberHelper';
import { PriceCartItem } from '@ace-clublabs/common-membership-api-types';
import { getCartProductName } from '../utils/helpers';
import { getFormattedDiscountedPrice } from '../utils/formatters';
import { IconName } from '@ace-clublabs/shared-component-library/dist/components/Icons';

interface ILineItem extends PriceCartItem {
  onDelete?: () => void;
  mask?: boolean;
  color?: string;
  icon?: IconName;
}

export const LineItem = ({
  price,
  discount,
  discountedPrice,
  description,
  code,
  onDelete,
  mask,
  color,
  icon,
}: ILineItem) => {
  const productType = getCartProductName(code);

  const deleteButton = onDelete ? (
    <IconButton aria-label={`remove-${productType}`} className={`remove-${productType}-button`} onClick={onDelete}>
      <Icon iconName="circle-x-solid" />
    </IconButton>
  ) : (
    <div style={{ marginRight: '44px' }} />
  );

  return (
    <div className={`${productType}-container`}>
      <hr className="overview-line"></hr>
      <div className="review-item-container">
        <Typography
          data-di-mask={`${mask ? 'true' : 'false'}`}
          className={`${productType}-description ${mask ? 'qm-mask' : ''}`}
          variant="b2Regular"
          sx={{ padding: '16px 0', color: color ? color : 'inherit' }}
        >
          {icon && <Icon iconName={icon} sx={{ fontSize: 'x-large', color: '#7527B9', height: '22px', width: '20px', paddingRight: '4px' }} />}
          {description}
        </Typography>
        <div className="flex-row-container">
          {discount! > 0 ? (
            <>
              {price ? (
                <Typography
                  variant="b2Regular"
                  className={`${productType}-full-price`}
                  sx={{ color: '#9E9E9E', textDecorationLine: 'line-through', marginRight: '8px' }}
                >
                  {numberHelper.formatMoney(price ?? 0)}
                </Typography>
              ) : (
                <></>
              )}

              {typeof discountedPrice == 'number' ? (
                <Typography
                  variant="b2Bold"
                  className={`${productType}-discounted-price`}
                  sx={{
                    color: '#7527B9',
                    fontWeight: '500',
                  }}
                >
                  {getFormattedDiscountedPrice(discountedPrice)}
                </Typography>
              ) : (
                <></>
              )}

              {deleteButton}
            </>
          ) : (
            <div className="flex-row-container">
              <Typography className={`${productType}-cost`} variant="b2Regular">
                {numberHelper.formatMoney(price ?? 0)}
              </Typography>
              {deleteButton}
            </div>
          )}
        </div>
      </div>
    </div>
  );
};
